// extracted by mini-css-extract-plugin
export default {"line_clamp":"terms_and_conditions_card_line_clamp__19582"};